// extracted by mini-css-extract-plugin
export default {"container":"styles_container_ZGCQY","heading":"styles_heading_IzKAq","message":"styles_message_JzgRs"};